<template>
  <div
    :id="id"
    :class="{
      'overflow-hidden': overflowHidden,
      'bg-transparent': isClear,
      'bg-white sm:shadow-xl sm:rounded-lg': !isClear,
      'p-0': isFullWidth,
      'p-0 md:p-6': !isFullWidth,
    }"
  >
    <div
      v-if="hasHeadingSlot"
      class="border-b border-neutral-200 px-4 py-6 sm:px-6"
    >
      <slot name="heading" />
    </div>
    <div :class="innerClass">
      <slot />
    </div>
    <div
      v-if="hasFooterSlot"
      class="border-t border-neutral-200 px-4 py-6 sm:px-6"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterCard',

  props: {
    overflowHidden: {
      type: Boolean,
      default: true,
    },
    isClear: {
      type: Boolean,
      default: false,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    hasHeadingSlot() {
      return this.$slots.heading && this.$slots.heading !== '';
    },
    hasFooterSlot() {
      return this.$slots.footer && this.$slots.footer !== '';
    },
    innerClass() {
      let theClass = 'py-5';
      if (this.isFullWidth) {
        theClass = 'py-0';
        if (this.isClear) {
          theClass += ' sm:py-0';
        }
      } else if (this.isClear) {
        theClass += ' sm:p-0';
      } else {
        theClass += ' sm:p-6';
      }

      return theClass;
    },
  },
};
</script>
